import React from 'react';

// Types
import { GoalItem } from 'Shared/constants/types';

// Utils
import { dateMMMDDYYYY } from 'Shared/utils/DateTime.utils';

// Components
import { WpIcon } from 'Wpds/components/icon';

// Styles
import './GoalCheckinDate.scss';

type Props = {
  goal: GoalItem;
};

const GoalCheckinDate = ({ goal }: Props) => {
  const nextCheckin = goal.nextCheckin ? dateMMMDDYYYY(goal.nextCheckin) : null;

  if (!goal.nextCheckin) return null;

  const baseClassName = 'GoalCheckinDate';

  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__icon`}>
        <WpIcon name="calendar-day" size="sm" />
      </div>
      {nextCheckin}
    </div>
  );
};

export default GoalCheckinDate;
